<!-- Tabs Navigation -->
@if (config.loadView) {
  <div class="tabs-container">
    @if (showTabs) {
      <div class="tabs-header">
        @if (data.gridConfig.prompt_config != undefined) {
          <div class="tab-with-dropdown">
            <div class="dropdown-wrapper" [class.open]="isDropdownOpen">
              <button class="dropdown-trigger" (click)="toggleDropdown()">
                <span class="selected-template">{{config.currentTemplate || 'Select Template'}}</span>
                <i class="fa fa-chevron-down" [class.rotated]="isDropdownOpen"></i>
              </button>
              <div class="dropdown-menu">
                @for (sPrompt of data.gridConfig.prompt_config; track sPrompt) {
                  <button class="dropdown-item"
                    [class.active]="config.currentTemplate === sPrompt.template_name"
                    (click)="selectTemplate(sPrompt.template_name)">
                    {{sPrompt.template_name}}
                  </button>
                }
              </div>
            </div>
          </div>
        }
        <button class="tab-button" [class.active]="activeTab === 'analysis'" (click)="switchTab('analysis')">
          AI Analysis
        </button>
        <button class="tab-button" [class.active]="activeTab === 'builder'" (click)="switchTab('builder')">
          AI Builder
        </button>
      </div>
    }
    @if (!showTabs && data.gridConfig.prompt_config != undefined && data.gridConfig.prompt_config.length>1) {
      <div class="tabs-header">
        @for (sPrompt of data.gridConfig.prompt_config; track sPrompt) {
          @if (sPrompt.isFeatureAvailable) {
            <button  class="tab-button" [class.active]="activeTab === 'analysis'" (click)="switchTab('analysis')"  [class.active]="config.currentTemplate === sPrompt.template_name"  [class.disabled]="config.loading && config.currentTemplate != sPrompt.template_name"
              (click)="selectTemplate(sPrompt.template_name)">
              {{sPrompt.template_name}}
            </button>
          }
        }
      </div>
    }
    <!-- Content Container -->
    <div [ngClass]="{'tab-content-ai': showTabs, 'full-content': !showTabs}">
      <!-- AI Analysis Content -->
      @if (!showTabs || activeTab === 'analysis') {
        <app-kx-ai-output [config]="config"></app-kx-ai-output>
      }
      <!-- Builder Content -->
      @if (showTabs && activeTab === 'builder') {
        <div class="builder-container">
          @if (builderAllowed) {
            <form [formGroup]="builderForm" (ngSubmit)="onSubmitPrompt()" class="builder-form">
              <!-- Left Section - Prompt -->
              <div class="prompt-section">
                @if (config.builderMode == 'ai_report') {
                  <div class="section-header">
                    <div class="child-code-tabs">
                      <button type="button" class="tab-button" [class.active]="activeQueryTab === 'code'" (click)="switchQueryTab('code')">
                        Generate Code
                      </button>
                      <button type="button" class="tab-button" [class.active]="activeQueryTab === 'schema'" (click)="switchQueryTab('schema')">
                        Generate Schema
                      </button>
                    </div>
                  </div>
                }
                <div class="section-header">
                  <h3>Describe what you want to generate</h3>
                </div>
                <div class="form-group">
                  <textarea
                    id="prompt"
                    formControlName="prompt"
                    class="form-control"
                    (input)="onTextareaInput('prompt',$event)"
                  ></textarea>
                  @if (builderForm.get('prompt').errors?.['latin1']) {
                    <div class="error-message">
                      Only Latin1/ISO-8859-1 characters are allowed
                    </div>
                  }
                  @if (activeQueryTab === 'schema') {
                    <div class="scan-container">
                      <ng-template #customComponent>
                      </ng-template>
                    </div>
                  }
                </div>
                <div class="button-group">
                  <button type="submit" class="btn btn-primary" [disabled]="!builderForm.valid">
                    <i class="fas fa-magic"></i> Generate
                  </button>
                </div>
              </div>
              <!-- Right Section - Code Editor -->
              <div class="code-section">
                <div class="section-header">
                  <div class="child-code-tabs" >
                    <button type="button" class="tab-button" [class.active]="activeCodeTab === 'generated'" (click)="switchCodeTab('generated')">
                      Generated Code
                    </button>
                    @if (config.builderMode == 'ai_report') {
                      <button type="button"  class="tab-button" [class.active]="activeCodeTab === 'prompt'" (click)="switchCodeTab('prompt')">
                        Schema
                      </button>
                    }
                    @if (config.builderMode != 'ai_report') {
                      <button type="button" class="tab-button" [class.active]="activeCodeTab === 'prompt'" (click)="switchCodeTab('prompt')">
                        Prompt
                      </button>
                    }
                  </div>
                </div>
                <div class="editor-container">
                  <div id="code-editor" class="ace-editor" [style.display]="activeCodeTab === 'generated' ? 'block' : 'none'"></div>
                  <div id="prompt-editor" [style.display]="activeCodeTab === 'prompt' ? 'block' : 'none'" style="height: 100%;">
                    <div id="schema-editor" class="ace-editor" [style.display]="config.builderMode === 'ai_report' ? 'block' : 'none'" style="height: 100%;">
                    </div>
                    <div class="form-group" [style.display]="config.builderMode == 'ai_report' ? 'none' : 'block'" style="height: 100%;">
                      <textarea
                        id="prompt_master"
                        formControlName="prompt_master"
                        class="form-control"
                        (input)="onTextareaInput('prompt_master',$event)"
                        style="height: calc(100% - 20px); resize: none;"
                      ></textarea>
                      @if (builderForm.get('prompt_master').errors?.['latin1']) {
                        <div class="error-message">
                          Only Latin1/ISO-8859-1 characters are allowed
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="editor-actions">
                  <button type="button" class="btn btn-primary" (click)="onSaveCode()">Save</button>
                </div>
              </div>
            </form>
          }
          @if (!builderAllowed) {
            <div class="builder-placeholder">
              <i class="fas fa-ban"></i>
              <h3>Action not allowed</h3>
              <p>{{config.errMsg}}</p>
            </div>
          }
        </div>
      }
    </div>
  </div>
}


@if (!config.loadView) {
  <div class="loader-container loader-container-1 loader">
    <ng-container>
      <div class="spinner"></div>
    </ng-container>
  </div>
}

